import { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";

/**
 * Default mapper to choose the right SEO document for the current path.
 * Assumes API returns an array: [{ page: { name }, title, metaDescription, metaKeywords, canonicalUrl }, ...]
 * Mapping rules:
 *  - "/" -> page.name === "home"
 *  - "/about" -> page.name === "about"
 *  - fallback: partial includes
 */
const defaultMapper = (seoArray) => {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const normalized = path === "/" ? "home" : path.replace(/^\//, "");

  const exactHome = seoArray.find(
    (s) => s?.page?.name?.toLowerCase() === "home" && normalized === "home"
  );
  if (exactHome) return exactHome;

  const directMatch = seoArray.find(
    (s) => s?.page?.name?.toLowerCase() === normalized.toLowerCase()
  );
  if (directMatch) return directMatch;

  const partial = seoArray.find((s) =>
    path.toLowerCase().includes((s?.page?.name || "").toLowerCase())
  );
  return partial || null;
};

export function useSeo(fetchUrl = "/getSeo", mapper = defaultMapper) {
  const [seo, setSeo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        setLoading(true);
        setError(null);
        const res = await axiosInstance.get(fetchUrl);
        
        
        const data = Array.isArray(res.data) ? res.data : [];
        const selected = mapper(data);
        
        
        if (!cancelled) setSeo(selected);
      } catch (err) {
        if (!cancelled) setError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [fetchUrl, mapper]);

  return { seo, loading, error };
}
